module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bindPhone"
  }, [_c('navtop', {
    attrs: {
      "index": 'bindPhone'
    }
  }), _vm._v(" "), (!_vm.hasBindPhone) ? _c('div', {
    staticClass: "con"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "phoneNum",
    attrs: {
      "type": "number",
      "placeholder": "请输入手机号"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "imgCodeWrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.yzImg),
      expression: "yzImg"
    }],
    staticClass: "imgCodeNum",
    attrs: {
      "type": "text",
      "placeholder": "请输入图形验证码"
    },
    domProps: {
      "value": (_vm.yzImg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.yzImg = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "codeImg",
    attrs: {
      "src": _vm.yzImgSrc
    },
    on: {
      "click": function($event) {
        _vm.yzImgSrc = _vm.yzImgSrc + '&v=' + Math.random()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "codeWrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    staticClass: "codeNum",
    attrs: {
      "type": "number",
      "placeholder": "请输入手机验证码"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "disabled": !(_vm.phoneState && _vm.yzImgState & _vm.timer)
    },
    on: {
      "click": _vm.getCode
    }
  }, [_vm._v(_vm._s(_vm.timerstr))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "password",
    attrs: {
      "type": "password",
      "placeholder": "请输入六位以上密码(可包含数字、字母或./-)"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bindBtn",
    attrs: {
      "disabled": !(_vm.phoneState && _vm.codeState && _vm.passwordState)
    },
    on: {
      "click": _vm.toBind
    }
  }, [_vm._v("绑定")])]) : _vm._e(), _vm._v(" "), (_vm.hasBindPhone) ? _c('div', {
    staticClass: "hasBind"
  }, [_c('p', {
    staticClass: "phone"
  }, [_vm._v(_vm._s(_vm.hasBindPhone.replace(/(\d{3})(\d{4})(\d{4})/, "$1****$3")))]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_vm._v("绑定手机号可用于此账号登录")]), _vm._v(" "), _c('div', {
    staticClass: "changeBtn",
    on: {
      "click": _vm.toChangePhone
    }
  }, [_vm._v("更改")])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2443b933","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dating/bindPhone.vue
// module id = 116
// module chunks = 0